// extracted by mini-css-extract-plugin
module.exports = {"joinDialog":"joindialog_joinDialog__2lx-q","inner":"joindialog_inner__1b4Zn"};